import React, { useState } from 'react';
import Text from '../../../../../../Components/Base/Text/Text';
import Button from '../../../../../../Components/Button/Button';
import { Theme } from '../../../../../../Enums/Theme.enum';
// @ts-ignore
import styles from './ManagerAddWorker.module.scss';
import ManagerAddWorkerByRegistrationModal from './ManagerAddWorkerByRegistrationModal';
import ManagerAddWorkerByInvitationModal from './ManagerAddWorkerByInvitationModal';

interface Props {
	onCreate: () => void;
}

const ManagerAddWorker: React.FC<Props> = ({ onCreate }) => {
	const [isRegistrationOpen, setIsRegistrationOpen] = useState(false);
	const [isInvitationOpen, setIsInvitationOpen] = useState(false);

	const onNewUserCreate = () => {
		setIsRegistrationOpen(false);
		setIsInvitationOpen(false);
		onCreate();
	};

	return (
		<>
			<div className={styles.wrapper}>
				<Text
					tx='component.workplaceAndWorkers.selectOneOptionHowToInviteColleagues'
					className={styles.title}
				/>
				<div>
					<Text
						tx='component.workplaceAndWorkers.registerColleague'
						className={styles.subtitle}
						firstUpper
					/>
					<Text tx='component.workplaceAndWorkers.text1' />
				</div>
				<div>
					<Text
						tx='component.workplaceAndWorkers.sendInviteToRegister'
						className={styles.subtitle}
						firstUpper
					/>
					<Text tx='component.workplaceAndWorkers.text2' />
				</div>
				<div className={styles.buttons}>
					<Button
						theme={Theme.BLUE}
						title='component.workplaceAndWorkers.registerColleague'
						onClick={() => setIsRegistrationOpen(true)}
					/>
					<Button
						theme={Theme.GREEN}
						title='component.workplaceAndWorkers.sendInviteToRegister'
						onClick={() => setIsInvitationOpen(true)}
					/>
				</div>
			</div>
			{isRegistrationOpen && (
				<ManagerAddWorkerByRegistrationModal
					isOpen
					onClose={() => setIsRegistrationOpen(false)}
					onCreate={onNewUserCreate}
				/>
			)}
			{isInvitationOpen && (
				<ManagerAddWorkerByInvitationModal
					isOpen
					onClose={() => setIsInvitationOpen(false)}
					onCreate={onNewUserCreate}
				/>
			)}
		</>
	);
};

export default ManagerAddWorker;
